var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6155 9.90804C21.1282 9.4058 21.1282 8.59018 20.6155 8.08795L15.3652 2.94509C14.8525 2.44286 14.0198 2.44286 13.5071 2.94509C12.9944 3.44732 12.9944 4.26295 13.5071 4.76518L16.5178 7.71429H7.87538C7.14937 7.71429 6.56282 8.28884 6.56282 9C6.56282 9.71116 7.14937 10.2857 7.87538 10.2857H16.5178L13.5071 13.2348C12.9944 13.7371 12.9944 14.5527 13.5071 15.0549C14.0198 15.5571 14.8525 15.5571 15.3652 15.0549L20.6155 9.91205V9.90804ZM6.56282 2.57143C7.28883 2.57143 7.87538 1.99688 7.87538 1.28571C7.87538 0.574554 7.28883 0 6.56282 0H3.93769C1.76376 0 0 1.72768 0 3.85714V14.1429C0 16.2723 1.76376 18 3.93769 18H6.56282C7.28883 18 7.87538 17.4254 7.87538 16.7143C7.87538 16.0031 7.28883 15.4286 6.56282 15.4286H3.93769C3.21168 15.4286 2.62513 14.854 2.62513 14.1429V3.85714C2.62513 3.14598 3.21168 2.57143 3.93769 2.57143H6.56282Z",
    fill: "#F17E5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3c2bf503350e94023ab54789a8784013.svg";
export { ForwardRef as ReactComponent };